<template>
  <div class="page-container" :class="isMobile ? 'page-container-mobile'  : 'page-container-pc'">
    <router-view />
  </div>
</template>
<script setup>
// import variables from './styles/variable.scss';
import { onMounted, onUnmounted, computed } from 'vue'
import { useStore } from 'vuex';

const store = useStore();
// 新增：计算属性获取 isMobile
const isMobile = computed(() => store.getters.isMobile);

// 设置初始窗口宽度
store.dispatch('updateWindowWidth', window.innerWidth);

const handleResize = () => {
  store.dispatch('updateWindowWidth', window.innerWidth);
};

onMounted(() => {
  window.addEventListener('resize', handleResize);
});

onUnmounted(() => {
  window.removeEventListener('resize', handleResize);
});

</script>
<style lang="scss">
.page-container-pc {
  .page-layout {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }
}
</style>
